/* eslint-disable */
import React from 'react';
interface FormattedSpeedProps {
  mbps: number;
}

const FormattedSpeed: React.FC<FormattedSpeedProps> = ({ mbps }) => {
  const isBinary = mbps % 1024 === 0;
  const divisor = isBinary ? 1024 : 1000;

  let value = mbps;
  let unit = 'Mbps';

  if (mbps >= divisor) {
    value = Math.round((mbps / divisor) * 100) / 100;
    unit = 'Gbps';
  }

  return (
    <>
      {value} {unit}
    </>
  );
};
export default FormattedSpeed;
